<template>
    <div class="text-center main">
        <h1 class="mt-10 mb-5">Vítejte v administraci Bzuco Inspector</h1>

        <v-btn v-if="!loggedUser" :to="{name:'login'}">Přihlásit</v-btn>
    </div>
</template>

<script>
    export default {
        computed: {
            loggedUser () {
                return this.$store.state.user.logged
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        width: 100%;
    }
</style>
